export default __webpack_public_path__ + "static/media/14613-403255-13351.ccc0c1df.jpg";